export default "__VITE_ASSET__bb9aeed4__"